import React from 'react';
import { Typography, RegularButton } from 'fronton-react';
import clsx from 'clsx';
import {
  suggestionContentWrap,
  suggestionIconWrap,
  suggestionTextContentWrap,
  suggestionPromoIconWrap,
  suggestionButton,
  suggestionText,
  suggestion,
} from './suggestion-list-item-styles';
import { SuggestionListItemPromoIcon } from './suggestion-list-item-promo-icon';
import { SuggestionsGaMetaInfo } from '../types';

export interface SuggestionListItemPromoPageProps {
  elementIndex: number;
  navigationIndex: number;
  isSrp: boolean;
  suggestionSelector: string;
  buttonAction: (
    id: number,
    linkToNavigate?: string,
    gaMeta?: SuggestionsGaMetaInfo
  ) => React.HTMLAttributes<HTMLButtonElement>;
}

export const SuggestionListItemPromoPage = (props: SuggestionListItemPromoPageProps) => {
  const { isSrp, navigationIndex, elementIndex, buttonAction } = props;

  return (
    <div role="option" aria-selected={elementIndex === navigationIndex} data-qa-header-search-suggestion="">
      <RegularButton
        variant="pseudo"
        tabIndex={-1}
        className={clsx(suggestion, {
          active: elementIndex === navigationIndex,
          [suggestionButton]: isSrp,
        })}
        data-qa="suggestion-button"
        {...buttonAction(elementIndex, '/promo/', {
          block: 'Акции',
          index: elementIndex,
          text: 'Выгодные предложения',
        })}
        href="/promo/">
        <div className={suggestionContentWrap}>
          <div className={clsx(suggestionIconWrap, suggestionPromoIconWrap)}>
            <SuggestionListItemPromoIcon />
          </div>
          <div className={suggestionTextContentWrap}>
            <Typography variant="m" size="body_short" className={suggestionText} color="text-primary">
              Выгодные предложения
            </Typography>
            <Typography variant="caption" color="text-secondary">
              Распродажи и акции
            </Typography>
          </div>
        </div>
      </RegularButton>
    </div>
  );
};
